import classNames from "classnames";
import ClosetItem from "./ClosetItem";

function ClosetItemsList({ closet, containerClassName, fromDrawer=true }) {
  return (
    <div className={classNames("closet-items-list-container", containerClassName)}>
      {closet.closet_items.map((closetItem) => (
        <ClosetItem
          key={closetItem.id}
          closetState={closet.state}
          closetItem={closetItem}
          fromDrawer={fromDrawer}
          closetHasMailboxPickingRequested={!!closet.mail_box_picking_date_requested_at}
        />
      ))}
    </div>
  );
}

export default ClosetItemsList;
